import {documenter} from 'doc/documenter.js';

export const doc = documenter();
